(function () {
  function init() {
    var wrapper = document.getElementById('MS__wrapper');
    if (!wrapper) return;
    var src = (wrapper.getAttribute('data-audio') || '').trim();
    if (!src) return;

    var audio = new Audio(src);
    audio.loop = true;
    audio.preload = 'auto';
    audio.muted = true;

    function syncButtons() {
      var audible = !audio.paused && !audio.muted;
      document.querySelectorAll('.btn-music').forEach(function (b) {
        b.classList.toggle('active', audible);
      });
    }

    audio.addEventListener('play', syncButtons);
    audio.addEventListener('pause', syncButtons);
    audio.addEventListener('ended', syncButtons);
    audio.addEventListener('volumechange', syncButtons);

    function tryPlay() {
      var p = audio.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
      return p;
    }

    tryPlay();

    var kickEvents = ['click', 'touchstart', 'keydown', 'scroll'];
    function removeKick() {
      kickEvents.forEach(function (ev) {
        document.removeEventListener(ev, kickStart, true);
      });
    }
    function start() {
      audio.muted = false;
      tryPlay();
      removeKick();
    }
    function kickStart(e) {
      if (e && e.target && e.target.closest && e.target.closest('.btn-music')) return;
      start();
    }
    kickEvents.forEach(function (ev) {
      document.addEventListener(ev, kickStart, true);
    });

    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.btn-music');
      if (!btn) return;
      e.preventDefault();
      if (audio.muted) {
        start();
        return;
      }
      if (audio.paused) {
        tryPlay();
      } else {
        audio.pause();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
